var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-heading"},[(_vm.heading)?_c('h3',{staticClass:"is-size-5"},[_vm._v(_vm._s(_vm.heading))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }